import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Backbone from 'backbone';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import app from '../../app';
import { UserServiceModel } from '../../settings/users/types';
import { ApolloIntegration, Tab } from './ApolloIntegration';

const template = require('./index.pug');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
      refetchOnMount: false,
    },
  },
});

export default Backbone.View.extend({
  async initialize(options: { tenant: number; queryString: string }) {
    this.tenant = options.tenant;
    this.integration = 'apollo';
    this.session = app.session;
    const user: UserServiceModel = this.session.get('user');

    this.hasAccessToConfigurations =
      user.permissions.some(
        (permission) =>
          permission.tenant === this.tenant && permission.role === 'admin'
      ) || user.superKudu;

    await this.renderApolloIntegrationComponent(this.tenant, user);

    this.onlyAdminTabsGuard();
  },

  onlyAdminTabsGuard() {
    if (!this.hasAccessToConfigurations) {
      this.changeTab('overview');
    }
  },

  getActiveTab(): Tab {
    const splitUrl = window.location.href.split('/');

    const lastItem = splitUrl[splitUrl.length - 1];
    if (lastItem === 'apollo' || !this.hasAccessToConfigurations)
      return 'overview';

    return lastItem as Tab;
  },

  changeTab(tab: Tab) {
    if (tab === 'overview') {
      Backbone.history.navigate(
        `/org/${this.tenant}/integrations/${this.integration}`
      );
    } else {
      Backbone.history.navigate(
        `/org/${this.tenant}/integrations/${this.integration}/${tab}`
      );
    }
  },

  async renderApolloIntegrationComponent() {
    // prepare dom for react component
    await this.$el.empty();
    this.$el.html(template());

    // render react component
    ReactDOM.render(
      <QueryClientProvider client={queryClient}>
        <ApolloIntegration
          tenant={this.tenant}
          onActiveTabChange={this.changeTab.bind(this)} // need to bind this to the function as it use this inside
          initialTab={this.getActiveTab()}
          hasAccessToConfiguration={this.hasAccessToConfigurations}
        />
      </QueryClientProvider>,
      $('#ApolloIntegrationContainer')[0]
    );
  },
});
